import React, {useState, useEffect, useRef} from 'react';
import {
    Layout
} from 'antd';


import { leftMenuToggle } from 'store/actions/home'
import { useActions } from '../../../../hooks/useActions'


const { Content } = Layout;


import './home.component.scss';




/*new*/
import {connect} from "react-redux";
import Account from "pages/Accounts/components/index";
import FullScreenLoading from "components/FullScreenLoading";
import {getCurrentCompany} from "../../../../services/user";


const HomePage:React.FC<any> = ({leftMenuStatus, loading}) => {

    return (
        <>
            { loading ? <FullScreenLoading/> : <Account/>}
        </>
    )
}

// <Account/>
const mapDispatchToProps = { leftMenuToggle }

const mapStateToProps = (state: any) => ({
    leftMenuStatus:  state.home.leftMenuStatus,
    loading: state.user.isCompChange
})


export default connect(mapStateToProps, mapDispatchToProps)(HomePage)
